<template>
  <div id="mMember">
    <Nav type="transparent" />
    <span class="pageTitle">会员服务</span>
    <div style="height: 1px;"></div>
    <div class="blockTit">会员特权及说明</div>
    <div class="card">
      <img src="../assets/member-icon4.png" alt />
      <div class="cardName">钻石卡 60,000RMB</div>
      <div class="cardInfo">
        <p>
          <strong>基础权益</strong>
        </p>
        <p>
          <span>·</span>
          <span>店内皮肤管理/头皮管理/身体智能管理部分项目享受7.5折优惠</span>
        </p>
        <p>
          <span>·</span>
          <span>产品购买8折优惠</span>
        </p>
      </div>
      <div class="cardInfo">
        <p>
          <strong>增值权益</strong>
        </p>
        <p>
          <span>·</span>
          <span>赠送pdp客用三品 价值612元</span>
        </p>
        <p>
          <span>·</span>
          <span>赠送日本碳酸泉头皮快捷净化服务项目5次，总价值790元</span>
        </p>
        <p>
          <span>·</span>
          <span>享受面部任意项目3次五折优惠</span>
        </p>
        <p>（原价值1000元以下项目）</p>
        <p>
          <span>·</span>
          <span>享受头皮任意项目3次五折优惠</span>
        </p>
        <p>（原价值1000元以下项目）</p>
        <p>
          <span>·</span>
          <span>INDIBA身体智能管理任意部位，5折优惠两次</span>
        </p>
        <p>
          <span>·</span>
          <span>可特殊会员价78元享受日本碳酸泉头皮快捷净化服务，不限次数</span>
        </p>
      </div>
    </div>
    <div class="card">
      <img src="../assets/member-icon3.png" alt />
      <div class="cardName">明星卡 29,800RMB</div>
      <div class="cardInfo">
        <p>
          <strong>基础权益</strong>
        </p>
        <p>
          <span>·</span>
          <span>店内皮肤管理/头皮管理/身体智能管理部分项目享受7.9折优惠</span>
        </p>
        <p>
          <span>·</span>
          <span>产品购买8折优惠</span>
        </p>
      </div>
      <div class="cardInfo">
        <p>
          <strong>增值权益</strong>
        </p>
        <p>
          <span>·</span>
          <span>赠送pdp美白/补水面膜一盒任选，价值138/168元</span>
        </p>
        <p>
          <span>·</span>
          <span>赠送日本碳酸泉头皮快捷净化服务项目2次，价值316元</span>
        </p>
        <p>
          <span>·</span>
          <span>享受日式PDP乳糖酸清洁管理2次五折优惠</span>
        </p>
        <p>
          <span>·</span>
          <span>INDIBA身体智能管理任意部位，5折优惠一次</span>
        </p>
        <p>
          <span>·</span>
          <span>可特殊会员价88元享受日本碳酸泉头皮快捷净化服务，不限次数</span>
        </p>
      </div>
    </div>
    <div class="card">
      <img src="../assets/member-icon2.png" alt />
      <div class="cardName">VIP卡 9,980RMB</div>
      <div class="cardInfo">
        <p>
          <strong>基础权益</strong>
        </p>
        <p>
          <span>·</span>
          <span>店内皮肤管理/头皮管理/身体智能管理部分项目享受8.5折优惠</span>
        </p>
        <p>
          <span>·</span>
          <span>产品购买8折优惠</span>
        </p>
      </div>
      <div class="cardInfo">
        <p>
          <strong>增值权益</strong>
        </p>
        <p>
          <span>·</span>
          <span>赠送pdp美白/补水面膜一盒任选，价值138/168元</span>
        </p>
        <p>
          <span>·</span>
          <span>赠送日本碳酸泉头皮快捷净化服务项目1次，价值158元</span>
        </p>
        <p>
          <span>·</span>
          <span>可特殊会员价98元享受日本碳酸泉头皮快捷净化服务，不限次数</span>
        </p>
      </div>
    </div>
    <div class="card">
      <img src="../assets/member-icon1.png" alt />
      <div class="cardName">体验卡 2,980RMB</div>
      <div class="cardInfo">
        <p>
          <strong>基础权益</strong>
        </p>
        <p>店内皮肤管理/头皮管理/身体智能管理部分项目享受9折优惠</p>
      </div>
    </div>
    <div class="cardNote">
      <p>*1.不与其他优惠同时享用</p>
      <p>2.赠送项目不可兑现，不可替换</p>
      <p>3.折扣以原价值计算</p>
      <p @click="table = true">
        4.特殊项目价格请参看会员价格体系&ensp;
        <mu-icon class="mIcon" size="26" value="info_outline"></mu-icon>
      </p>
    </div>
    <div class="luckdraw">
      <router-link to="/Luckdraw"><img src="../assets/luckdraw/link.png" alt=""></router-link>
    </div>
    <div class="blockTit">会员规则</div>
    <div class="blockText">
      <p>
        <span>1.</span>
        <span>本会员卡仅限绑定一名持卡人，持卡人有权与他人共享使用。持卡人不在场的情况下，店铺需与持卡人取得联系，以便对用卡人进行身份确认，方可借让他人使用。如无法联系到持卡人，店铺有权拒绝本次持卡消费。</span>
      </p>
      <p>
        <span>2.</span>
        <span>本卡不设置有效期。</span>
      </p>
      <p>
        <span>3.</span>
        <span>店铺为预约制，所有项目（包括赠予项目）皆需预约后方可消费。如未经预约，店铺有权拒绝操作。</span>
      </p>
      <p>
        <span>4.</span>
        <span>会员需按预约时间准时到店，迟到15分钟以上，店铺有权拒绝操作。</span>
      </p>
      <p>
        <span>5.</span>
        <span>操作过程中全程禁止录像。</span>
      </p>
    </div>
    <div class="blockTit">关于解约</div>
    <div class="blockText">
      <p>
        <span>1.</span>
        <span>因会员客观原因（长期出差、公派出国、入院手续、怀孕）需要解除合约，店铺同意其自行转卡，赠送项目和已消费项目，无需折算原价，剩余权益和余额，皆不做更改。如办理转卡，需双方到店，另行办理转卡手续。</span>
      </p>
      <p>
        <span>2.</span>
        <span>因会员客观原因（长期出差，公派出国，入院手续，怀孕）要求解除合约，将按各项目原价格进行已消费项目、产品的重新核算，原价格以店面正在执行的价格为准，只返还原价格抵扣后的余额部分。</span>
      </p>
      <p>
        <span>3.</span>
        <span>入会后的赠予部分，如产品赠予、项目赠予等，将按已赠予的各项目、产品的原价格进行核算，原价格以店面正在执行的价格为准，只返还原价格抵扣后的余额部分。</span>
      </p>
      <p>
        <span>4.</span>
        <span>确认解约，需缴纳原值核算后，剩余金额的20%作为违约金。</span>
      </p>
      <p>
        <span>5.</span>
        <span>解约流程，需要客户实际到店办理，签署退款确认函后，方可进入正式退款流程。如客户不方便到店，店面有权通过电话、语音等方式核实客户身份，以保证客户资金安全。</span>
      </p>
      <p>
        <span>6.</span>
        <span>解约退款仅限银行卡，微信，支付宝几种形式。</span>
      </p>
      <p>
        <span>7.</span>
        <span>退款流程为7-10个工作日。</span>
      </p>
      <p>
        <span>8.</span>
        <span>因店铺原因（店铺拆迁，暂停运营）要求解约，为店面责任，按会员折扣价与客户确认卡内余额后，在15个工作日内退还全部余额，同时支付未消费金额的20%给客户作为违约金。赠予部分无需返还。</span>
      </p>
    </div>
    <mu-dialog title class="mTable" width="750" :open.sync="table">
      <i class="close" @click="table = false"></i>
      <!-- <ul class="mBody">
            <li v-for="(item, i) in list" :key="i" :class="{ active: i == active }" @click="setActive(i)">
                <div class="mTable__title" :style="{'background-image': `url(${item.icon})`}">{{item.name}}<span class="icon">&or;</span></div>
                <ul class="mTable__detail">
                    <li>
                        <div>项目时间</div>
                        <div>{{item.duration}}</div>
                    </li>
                    <li>
                        <div>门市价格</div>
                        <div>{{item.price}}</div>
                    </li>
                    <li>
                        <div>
                            <span :class="`priceIcon level1`"></span>
                            <span class="priceName">VIP卡</span>
                        </div>
                        <div>{{item.level1}}</div>
                    </li>
                    <li>
                        <div>
                            <span :class="`priceIcon level2`"></span>
                            <span class="priceName">明星卡</span>
                        </div>
                        <div>{{item.level2}}</div>
                    </li>
                    <li>
                        <div>
                            <span :class="`priceIcon level3`"></span>
                            <span class="priceName">钻石卡</span>
                        </div>
                        <div>{{item.level3}}</div>
                    </li>
                </ul>
            </li>
      </ul>-->
      <div class="imgBox">
        <img src="../assets/pageM.png" alt />
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
export default {
  name: "Member",
  data() {
    return {
      // table: false,
      active: -1,
      table: false,
      list: [
        {
          name: "日式PDP乳糖酸清洁",
          duration: "60分",
          price: "¥738",
          level1: "¥627",
          level2: "¥583",
          level3: "¥554",
          icon: require("../assets/m-icon2.png")
        },
        {
          name: "无针水光深层补水",
          duration: "60分",
          price: "¥718",
          level1: "610",
          level2: "¥567",
          level3: "¥539",
          icon: require("../assets/m-icon3.png")
        },
        {
          name: "Whisper",
          duration: "40分",
          price: "¥1600",
          level1: "¥1360",
          level2: "¥1264",
          level3: "¥1200",
          icon: require("../assets/m-icon1.png")
        },
        {
          name: "日式黑头深层清洁",
          duration: "40分",
          price: "¥308",
          level1: "¥262",
          level2: "¥243",
          level3: "¥231",
          icon: require("../assets/m-icon4.png")
        },
        {
          name: "镇静舒缓管理",
          duration: "60分",
          price: "¥498",
          level1: "¥423",
          level2: "¥393",
          level3: "¥374",
          icon: require("../assets/m-icon8.png")
        },
        {
          name: "日本高纯VC亮肤美白",
          duration: "60分",
          price: "¥838",
          level1: "¥712",
          level2: "¥662",
          level3: "¥629",
          icon: require("../assets/m-icon5.png")
        },
        {
          name: "MTS皮肤再生",
          duration: "60分",
          price: "¥1608",
          level1: "¥1367",
          level2: "¥1270",
          level3: "¥1206",
          icon: require("../assets/m-icon7.png")
        },
        {
          name: "Core Design日本筋膜 提升小颜紧致管理",
          duration: "60分",
          price: "¥728",
          level1: "¥619",
          level2: "¥575",
          level3: "¥546",
          icon: require("../assets/m-icon6.png")
        },
        {
          name: "日本碳酸泉快捷头皮净化",
          duration: "15分",
          price: "¥108",
          level1: "¥78",
          level2: "¥68",
          level3: "¥58",
          icon: require("../assets/m-icon11.png")
        },
        {
          name: "Head Spa日本碳酸泉头皮抗衰舒缓",
          duration: "60分",
          price: "¥568",
          level1: "¥483",
          level2: "¥449",
          level3: "¥426",
          icon: require("../assets/m-icon9.png")
        },
        {
          name: "APURE头皮高级净化",
          duration: "60分",
          price: "¥688",
          level1: "¥585",
          level2: "¥544",
          level3: "¥516",
          icon: require("../assets/m-icon10.png")
        }
      ],
      columns: [
        { title: "项目", width: 300, name: "name" },
        { title: "项目时间", width: 160, name: "duration" },
        { title: "门市价格", width: 160, name: "price" },
        { title: "VIP卡", width: 160, name: "level1" },
        { title: "明星卡", width: 160, name: "level2" },
        { title: "钻石卡", width: 160, name: "level3" }
      ]
    };
  },
  components: {
    Nav
  },
  computed: {},
  methods: {
    setActive(i) {
      this.active = this.active === i ? -1 : i;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
#mMember {
  padding: 350px 32px 140px;
  background: url(../assets/member-banner.jpg) top/100% no-repeat;
}
.blockTit {
  margin: 104px 0 56px;
}
.blockText {
  font-size: 28px;
  line-height: 48px;
  text-align: left;
  > p {
    display: flex;
    > span:last-child {
      flex: 1;
    }
  }
}
.card {
  margin: 32px auto 0;
  padding: 80px 28px;
  width: 686px;
  background: #f8f9f8;
  > img {
    display: block;
    margin: 0 auto;
  }
  .cardName {
    margin: 40px 0 64px;
    font-size: 30px;
    line-height: 32px;
    color: #333;
    text-align: center;
  }
  .cardInfo {
    margin-top: 40px;
    font-size: 28px;
    line-height: 48px;
    color: #555;
    > p {
      display: flex;
      > span:last-child {
        flex: 1;
      }
    }
  }
}
.cardNote {
  margin: 16px 0 0 10px;
  font-size: 20px;
  line-height: 32px;
  color: #b0b0b0;
}
.mIcon {
  position: relative;
  top: 6px;
  color: #d1d1d1;
}
.luckdraw {
    display: flex;
    justify-content: center;
    align-items: center;
    
    img {
      display: block;
      margin: 128px 0 24px;
      width: 686px;
    }
  }
</style>